
<div [id]="widgetMeta.id"></div>
<div class="full-chart-container" #fullChart fxLayout="row" fxLayoutAlign="center center"></div>
